<input 
  type="text"
  class="form-input"
  [placeholder]="placeholder"
  [value]="displayValue"
  (input)="onInput($event)"
  (focus)="onFocus($event)"
  (blur)="onBlur()"
/>
<div class="w-full max-w-[636px] border border-[color:var(--gray-100,#e8e8e8)] shadow-[0_4px_13px_#ababab14] my-auto rounded-[0_0_8px_8px_/_0px_0px_8px_8px] border-solid absolute top-[49.33px] z-10 bg-[#fff] max-h-[261px] overflow-hidden overflow-y-auto origin-top webkit-drop-container"
[@stateOrCountryDropdownAnimation] 
*ngIf="showDropdown && filteredOptions.length > 0"
>
  <div 
    class="rounded-[0_0_8px_8px_/_0px_0px_8px_8px] h-full flex flex-col gap-4 pb-6 pt-4 px-6"
    tabindex="0"
    *ngFor="let option of filteredOptions"
    (click)="selectOption(option)"
    (keydown.enter)="selectOption(option)">
    <span class="text-[#333333] font-normal tracking-1percent leading-6 cursor-pointer">{{ option.name }}</span>
  </div>
</div>